import React, { useEffect, useState } from 'react';
import api, { retrageConsimtamant, trimiteCerereGDPR, getCereriGDPR, salveazaReminder, updateMarketingConsent } from '../services/api';

const OPTIUNI_PROBLEMA = ['Sciatică','Hernie de disc lombară','Durere lombară nespecifică','Sindrom piriform','Durere cervicală','Altă problemă de spate'];
const OPTIUNI_DURATA = ['Sub 2 săptămâni','2-6 săptămâni','1-6 luni','Peste 6 luni','Ani de zile'];
const OPTIUNI_VARSTA = ['18-30 ani','31-45 ani','46-60 ani','Peste 60 ani'];
const OPTIUNI_STIL = ['Sedentar (birou, condus mult)','Moderat activ','Activ fizic'];

const Profil: React.FC = () => {
  const [profil, setProfil] = useState<any>(null);
  const [badges, setBadges] = useState<any[]>([]);
  const [streak, setStreak] = useState(0);
  const [editare, setEditare] = useState(false);
  const [form, setForm] = useState<any>(null);
  const [saving, setSaving] = useState(false);
  const [mesaj, setMesaj] = useState('');
  const [cereriGDPR, setCereriGDPR] = useState<any[]>([]);
  const [reminderActiv, setReminderActiv] = useState(false);
  const [reminderOra, setReminderOra] = useState(8);
  const [savingReminder, setSavingReminder] = useState(false);
  const [mesajReminder, setMesajReminder] = useState('');
  const [acceptedMarketing, setAcceptedMarketing] = useState(false);
  const [savingMarketing, setSavingMarketing] = useState(false);
  const [mesajMarketing, setMesajMarketing] = useState('');
  const [tipCerere, setTipCerere] = useState('Acces la date (Art. 15)');
  const [descriereCerere, setDescriereCerere] = useState('');
  const [trimitCerere, setTrimiCerere] = useState(false);
  const [mesajCerere, setMesajCerere] = useState('');

  useEffect(() => {
    Promise.all([
      api.get('/profil/get'),
      api.get('/tracker/badges'),
      api.get('/tracker/streak'),
      getCereriGDPR(),
    ]).then(([profilRes, badgesRes, streakRes, cereriRes]) => {
      setProfil(profilRes.data);
      setBadges(badgesRes.data);
      setStreak(streakRes.data.streak);
      setCereriGDPR(cereriRes.data);
      setReminderActiv(profilRes.data?.reminder_activ || false);
      setReminderOra(profilRes.data?.reminder_ora ?? 8);
      setAcceptedMarketing(profilRes.data?.accepted_marketing || false);
    }).catch(() => {});
  }, []);

  const descarcaFisier = async (endpoint: string, filename: string) => {
    const token = localStorage.getItem('token');
    const res = await fetch(`${process.env.REACT_APP_API_URL}${endpoint}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    a.click();
    URL.revokeObjectURL(url);
  };

  const deschideEditare = () => {
    setForm({
      nume: profil.nume || '',
      problema: profil.problema || OPTIUNI_PROBLEMA[0],
      durata_problema: profil.durata_problema || OPTIUNI_DURATA[0],
      varsta: profil.varsta || OPTIUNI_VARSTA[0],
      stil_viata: profil.stil_viata || OPTIUNI_STIL[0],
      obiectiv: profil.obiectiv || '',
      nivel_durere_initial: profil.nivel_durere_initial || 5,
    });
    setMesaj('');
    setEditare(true);
  };

  const handleSalveaza = async () => {
    if (!form.nume.trim()) { setMesaj('Numele nu poate fi gol!'); return; }
    setSaving(true);
    setMesaj('');
    try {
      await api.post('/profil/salveaza', form);
      const res = await api.get('/profil/get');
      setProfil(res.data);
      setEditare(false);
      setMesaj('✅ Profil actualizat!');
      setTimeout(() => setMesaj(''), 3000);
    } catch {
      setMesaj('❌ Eroare la salvare. Încearcă din nou.');
    } finally {
      setSaving(false);
    }
  };

  const inputStyle: React.CSSProperties = {
    padding: '0.6rem 0.75rem', borderRadius: '8px',
    border: '1.5px solid #2a2a4a', background: '#12121f',
    color: '#e0e0f0', fontSize: '0.9rem', width: '100%',
    boxSizing: 'border-box'
  };

  return (
    <div style={{ padding: '2rem', maxWidth: '820px', margin: '0 auto', fontFamily: 'DM Sans, sans-serif' }}>
      <h2 style={{ color: '#fff', marginBottom: '0.5rem' }}>👤 Profilul meu</h2>
      <p style={{ color: '#8080a0', marginBottom: '2rem' }}>Informațiile și progresul tău.</p>

      {mesaj && !editare && (
        <p style={{ color: mesaj.startsWith('✅') ? '#60d090' : '#d06060', marginBottom: '1rem', fontSize: '0.9rem' }}>{mesaj}</p>
      )}

      {profil && (
        <div style={{ background: '#1a1a30', borderRadius: '16px', padding: '1.5rem', border: '1px solid #2a2a4a', marginBottom: '1.5rem' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
            <h3 style={{ color: '#fff', margin: 0 }}>Informații personale</h3>
            {!editare && (
              <button onClick={deschideEditare} style={{
                padding: '0.4rem 1rem', borderRadius: '8px',
                border: '1px solid #4a4ad8', background: 'transparent',
                color: '#8080d8', cursor: 'pointer', fontSize: '0.85rem'
              }}>
                ✏️ Editează
              </button>
            )}
          </div>

          {!editare ? (
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
              {[
                { label: 'Nume', value: profil.nume },
                { label: 'Problemă', value: profil.problema },
                { label: 'Durată', value: profil.durata_problema },
                { label: 'Vârstă', value: profil.varsta },
                { label: 'Stil viață', value: profil.stil_viata },
              ].map((item, i) => (
                <div key={i}>
                  <p style={{ color: '#6060a0', fontSize: '0.75rem', textTransform: 'uppercase', margin: '0 0 0.2rem' }}>{item.label}</p>
                  <p style={{ color: '#e0e0f0', margin: 0 }}>{item.value}</p>
                </div>
              ))}
              {profil.obiectiv && (
                <div style={{ gridColumn: '1 / -1', background: '#1a2a1a', borderRadius: '8px', padding: '0.75rem', marginTop: '0.25rem' }}>
                  <p style={{ color: '#60d090', margin: 0 }}>🎯 <strong>Obiectiv:</strong> {profil.obiectiv}</p>
                </div>
              )}
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem' }}>
                <div>
                  <label style={{ color: '#6060a0', fontSize: '0.75rem', textTransform: 'uppercase', display: 'block', marginBottom: '0.3rem' }}>Nume</label>
                  <input value={form.nume} onChange={e => setForm({ ...form, nume: e.target.value })} style={inputStyle} />
                </div>
                <div>
                  <label style={{ color: '#6060a0', fontSize: '0.75rem', textTransform: 'uppercase', display: 'block', marginBottom: '0.3rem' }}>Vârstă</label>
                  <select value={form.varsta} onChange={e => setForm({ ...form, varsta: e.target.value })} style={inputStyle}>
                    {OPTIUNI_VARSTA.map(v => <option key={v}>{v}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ color: '#6060a0', fontSize: '0.75rem', textTransform: 'uppercase', display: 'block', marginBottom: '0.3rem' }}>Problemă</label>
                  <select value={form.problema} onChange={e => setForm({ ...form, problema: e.target.value })} style={inputStyle}>
                    {OPTIUNI_PROBLEMA.map(v => <option key={v}>{v}</option>)}
                  </select>
                </div>
                <div>
                  <label style={{ color: '#6060a0', fontSize: '0.75rem', textTransform: 'uppercase', display: 'block', marginBottom: '0.3rem' }}>Durată problemă</label>
                  <select value={form.durata_problema} onChange={e => setForm({ ...form, durata_problema: e.target.value })} style={inputStyle}>
                    {OPTIUNI_DURATA.map(v => <option key={v}>{v}</option>)}
                  </select>
                </div>
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={{ color: '#6060a0', fontSize: '0.75rem', textTransform: 'uppercase', display: 'block', marginBottom: '0.3rem' }}>Stil de viață</label>
                  <select value={form.stil_viata} onChange={e => setForm({ ...form, stil_viata: e.target.value })} style={inputStyle}>
                    {OPTIUNI_STIL.map(v => <option key={v}>{v}</option>)}
                  </select>
                </div>
                <div style={{ gridColumn: '1 / -1' }}>
                  <label style={{ color: '#6060a0', fontSize: '0.75rem', textTransform: 'uppercase', display: 'block', marginBottom: '0.3rem' }}>Obiectiv</label>
                  <input value={form.obiectiv} onChange={e => setForm({ ...form, obiectiv: e.target.value })}
                    placeholder="Ex: Să reduc durerea de la 7 la 3 în 30 de zile"
                    style={inputStyle} />
                </div>
              </div>

              {mesaj && (
                <p style={{ color: mesaj.startsWith('✅') ? '#60d090' : '#d06060', fontSize: '0.85rem', margin: 0 }}>{mesaj}</p>
              )}

              <div style={{ display: 'flex', gap: '0.75rem', marginTop: '0.25rem' }}>
                <button onClick={() => setEditare(false)} style={{
                  flex: 1, padding: '0.6rem', borderRadius: '8px',
                  border: '1px solid #2a2a4a', background: 'transparent',
                  color: '#8080a0', cursor: 'pointer', fontSize: '0.9rem'
                }}>Anulează</button>
                <button onClick={handleSalveaza} disabled={saving} style={{
                  flex: 2, padding: '0.6rem', borderRadius: '8px', border: 'none',
                  background: saving ? '#2a2a4a' : '#4a4ad8', color: '#fff',
                  cursor: saving ? 'not-allowed' : 'pointer', fontWeight: 600, fontSize: '0.9rem',
                  opacity: saving ? 0.7 : 1
                }}>{saving ? 'Se salvează...' : 'Salvează modificările'}</button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Stats */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem', marginBottom: '1.5rem' }}>
        <div style={{ background: '#1a1a30', borderRadius: '12px', padding: '1rem', border: '1px solid #2a2a4a', textAlign: 'center' }}>
          <p style={{ color: '#6060a0', fontSize: '0.7rem', textTransform: 'uppercase', margin: '0 0 0.25rem' }}>Seria curentă</p>
          <p style={{ color: '#fff', fontWeight: 600, fontSize: '1.5rem', margin: 0 }}>{streak} zile</p>
        </div>
        <div style={{ background: '#1a1a30', borderRadius: '12px', padding: '1rem', border: '1px solid #2a2a4a', textAlign: 'center' }}>
          <p style={{ color: '#6060a0', fontSize: '0.7rem', textTransform: 'uppercase', margin: '0 0 0.25rem' }}>Badge-uri</p>
          <p style={{ color: '#fff', fontWeight: 600, fontSize: '1.5rem', margin: 0 }}>{badges.length}</p>
        </div>
      </div>

      {/* Badges */}
      {badges.length > 0 && (
        <div style={{ background: '#1a1a30', borderRadius: '16px', padding: '1.5rem', border: '1px solid #2a2a4a', marginBottom: '1.5rem' }}>
          <h3 style={{ color: '#fff', marginBottom: '1rem' }}>Realizările tale</h3>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: '0.75rem' }}>
            {badges.map((b, i) => (
              <div key={i} style={{ background: '#12121f', borderRadius: '10px', padding: '0.75rem', textAlign: 'center' }}>
                <p style={{ fontSize: '1.5rem', margin: '0 0 0.25rem' }}>{b.icon}</p>
                <p style={{ color: '#fff', fontWeight: 600, fontSize: '0.8rem', margin: '0 0 0.2rem' }}>{b.titlu}</p>
                <p style={{ color: '#6060a0', fontSize: '0.72rem', margin: 0 }}>{b.desc}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Reminder zilnic */}
      <div style={{ background: '#1a1a30', borderRadius: '16px', padding: '1.5rem', border: '1px solid #2a2a4a', marginBottom: '1.5rem' }}>
        <h3 style={{ color: '#fff', marginBottom: '0.5rem' }}>🔔 Reminder zilnic exerciții</h3>
        <p style={{ color: '#6060a0', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
          Primești un email zilnic la ora aleasă ca să nu uiți de exerciții.
        </p>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
          <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', cursor: 'pointer' }}>
            <input
              type="checkbox"
              checked={reminderActiv}
              onChange={e => setReminderActiv(e.target.checked)}
              style={{ accentColor: '#4a4ad8', width: '18px', height: '18px' }}
            />
            <span style={{ color: '#e0e0f0', fontSize: '0.9rem' }}>Activează reminder</span>
          </label>
          {reminderActiv && (
            <select
              value={reminderOra}
              onChange={e => setReminderOra(parseInt(e.target.value))}
              style={{ ...inputStyle, width: 'auto' }}
            >
              {Array.from({ length: 24 }, (_, i) => (
                <option key={i} value={i}>{String(i).padStart(2, '0')}:00</option>
              ))}
            </select>
          )}
        </div>
        {mesajReminder && (
          <p style={{ color: mesajReminder.startsWith('✅') ? '#60d090' : '#d06060', fontSize: '0.85rem', marginBottom: '0.75rem' }}>{mesajReminder}</p>
        )}
        <button onClick={async () => {
          setSavingReminder(true);
          setMesajReminder('');
          try {
            await salveazaReminder(reminderActiv, reminderOra);
            setMesajReminder(reminderActiv ? `✅ Reminder activ zilnic la ${String(reminderOra).padStart(2, '0')}:00` : '✅ Reminder dezactivat');
            setTimeout(() => setMesajReminder(''), 3000);
          } catch {
            setMesajReminder('❌ Eroare la salvare.');
          } finally {
            setSavingReminder(false);
          }
        }} disabled={savingReminder} style={{
          padding: '0.6rem 1.2rem', borderRadius: '8px', border: 'none',
          background: savingReminder ? '#2a2a4a' : '#4a4ad8', color: '#fff',
          cursor: savingReminder ? 'not-allowed' : 'pointer', fontWeight: 600,
          fontSize: '0.9rem', opacity: savingReminder ? 0.7 : 1
        }}>
          {savingReminder ? 'Se salvează...' : 'Salvează'}
        </button>
      </div>

      {/* GDPR */}
      <div style={{ background: '#1a1a30', borderRadius: '16px', padding: '1.5rem', border: '1px solid #2a2a4a', marginBottom: '1.5rem' }}>
        <h3 style={{ color: '#fff', marginBottom: '0.5rem' }}>📁 Datele tale (GDPR)</h3>
        <p style={{ color: '#6060a0', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
          Conform Art. 15 GDPR ai dreptul să descarci toate datele stocate despre tine.
        </p>
        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
          <button onClick={() => descarcaFisier('/gdpr/descarca-json', `flexara_date_${new Date().toISOString().slice(0,10)}.json`)}
            style={{
              padding: '0.6rem 1.2rem', borderRadius: '8px',
              border: '1px solid #2a2a4a', background: '#12121f',
              color: '#a0a0c0', cursor: 'pointer', fontSize: '0.9rem'
            }}>
            ⬇️ Descarcă JSON
          </button>
          <button onClick={() => descarcaFisier('/gdpr/descarca-pdf', `flexara_date_${new Date().toISOString().slice(0,10)}.pdf`)}
            style={{
              padding: '0.6rem 1.2rem', borderRadius: '8px',
              border: '1px solid #2a2a4a', background: '#12121f',
              color: '#a0a0c0', cursor: 'pointer', fontSize: '0.9rem'
            }}>
            ⬇️ Descarcă PDF
          </button>
        </div>
      </div>

      {/* Cereri formale GDPR */}
      <div style={{ background: '#1a1a30', borderRadius: '16px', padding: '1.5rem', border: '1px solid #2a2a4a', marginBottom: '1.5rem' }}>
        <h3 style={{ color: '#fff', marginBottom: '0.5rem' }}>📋 Cereri formale GDPR</h3>
        <p style={{ color: '#6060a0', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
          Dacă ai o solicitare care nu poate fi rezolvată prin opțiunile de mai sus, trimite o cerere formală.
          Vei primi răspuns în maxim 30 de zile (Art. 12 GDPR).
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem', marginBottom: '1rem' }}>
          <select value={tipCerere} onChange={e => setTipCerere(e.target.value)} style={inputStyle}>
            {['Acces la date (Art. 15)', 'Rectificare date (Art. 16)', 'Restricționare procesare (Art. 18)',
              'Portabilitate date (Art. 20)', 'Opoziție procesare (Art. 21)', 'Altă cerere GDPR'
            ].map(t => <option key={t}>{t}</option>)}
          </select>
          <textarea
            value={descriereCerere}
            onChange={e => setDescriereCerere(e.target.value)}
            placeholder="Descrie cererea ta (opțional, max 1000 caractere)"
            maxLength={1000}
            rows={3}
            style={{ ...inputStyle, resize: 'vertical' }}
          />
          {mesajCerere && (
            <p style={{ color: mesajCerere.startsWith('✅') ? '#60d090' : '#d06060', fontSize: '0.85rem', margin: 0 }}>{mesajCerere}</p>
          )}
          <button onClick={async () => {
            setTrimiCerere(true);
            setMesajCerere('');
            try {
              const res = await trimiteCerereGDPR(tipCerere, descriereCerere || undefined);
              setMesajCerere(`✅ Cerere înregistrată. Termen răspuns: ${res.data.deadline}`);
              setDescriereCerere('');
              const cereriRes = await getCereriGDPR();
              setCereriGDPR(cereriRes.data);
            } catch {
              setMesajCerere('❌ Eroare la trimitere. Încearcă din nou.');
            } finally {
              setTrimiCerere(false);
            }
          }} disabled={trimitCerere} style={{
            padding: '0.6rem 1.2rem', borderRadius: '8px', border: 'none',
            background: trimitCerere ? '#2a2a4a' : '#4a4ad8', color: '#fff',
            cursor: trimitCerere ? 'not-allowed' : 'pointer', fontWeight: 600,
            fontSize: '0.9rem', opacity: trimitCerere ? 0.7 : 1
          }}>
            {trimitCerere ? 'Se trimite...' : 'Trimite cererea'}
          </button>
        </div>

        {cereriGDPR.length > 0 && (
          <div>
            <p style={{ color: '#6060a0', fontSize: '0.75rem', textTransform: 'uppercase', marginBottom: '0.5rem' }}>Cererile tale</p>
            {cereriGDPR.map((c, i) => (
              <div key={i} style={{ background: '#12121f', borderRadius: '8px', padding: '0.75rem', marginBottom: '0.5rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ color: '#e0e0f0', fontSize: '0.85rem', fontWeight: 600 }}>{c.tip_cerere}</span>
                  <span style={{
                    fontSize: '0.75rem', padding: '0.15rem 0.5rem', borderRadius: '4px',
                    background: c.status === 'rezolvat' ? '#1a3a1a' : '#2a2a0a',
                    color: c.status === 'rezolvat' ? '#60d090' : '#d0a040'
                  }}>
                    {c.status === 'rezolvat' ? 'Rezolvat' : 'În așteptare'}
                  </span>
                </div>
                <p style={{ color: '#6060a0', fontSize: '0.75rem', margin: '0.25rem 0 0' }}>
                  Trimisă: {c.created_at} · Termen: {c.deadline_at}
                  {c.rezolvat_la && ` · Rezolvat: ${c.rezolvat_la}`}
                </p>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* Comunicari marketing */}
      <div style={{ background: '#1a1a30', borderRadius: '16px', padding: '1.5rem', border: '1px solid #2a2a4a', marginBottom: '1.5rem' }}>
        <h3 style={{ color: '#fff', marginBottom: '0.5rem' }}>📧 Comunicări comerciale</h3>
        <p style={{ color: '#6060a0', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
          Controlează dacă dorești să primești noutăți, sfaturi de sănătate și oferte de la Flexara prin email.
          Poți modifica această preferință oricând.
        </p>
        <label style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', cursor: 'pointer', marginBottom: '1rem' }}>
          <input
            type="checkbox"
            checked={acceptedMarketing}
            onChange={e => setAcceptedMarketing(e.target.checked)}
            style={{ accentColor: '#4a4ad8', width: '18px', height: '18px' }}
          />
          <span style={{ color: '#e0e0f0', fontSize: '0.9rem' }}>
            Doresc să primesc comunicări comerciale de la Flexara
          </span>
        </label>
        {mesajMarketing && (
          <p style={{ color: mesajMarketing.startsWith('✅') ? '#60d090' : '#d06060', fontSize: '0.85rem', marginBottom: '0.75rem' }}>{mesajMarketing}</p>
        )}
        <button onClick={async () => {
          setSavingMarketing(true);
          setMesajMarketing('');
          try {
            await updateMarketingConsent(acceptedMarketing);
            setMesajMarketing(acceptedMarketing ? '✅ Comunicări comerciale activate' : '✅ Dezabonat de la comunicări comerciale');
            setTimeout(() => setMesajMarketing(''), 3000);
          } catch {
            setMesajMarketing('❌ Eroare la salvare.');
          } finally {
            setSavingMarketing(false);
          }
        }} disabled={savingMarketing} style={{
          padding: '0.6rem 1.2rem', borderRadius: '8px', border: 'none',
          background: savingMarketing ? '#2a2a4a' : '#4a4ad8', color: '#fff',
          cursor: savingMarketing ? 'not-allowed' : 'pointer', fontWeight: 600,
          fontSize: '0.9rem', opacity: savingMarketing ? 0.7 : 1
        }}>
          {savingMarketing ? 'Se salvează...' : 'Salvează preferința'}
        </button>
      </div>

      {/* Retragere consimțământ */}
      <div style={{ background: '#1a1a30', borderRadius: '16px', padding: '1.5rem', border: '1px solid #2a2a4a', marginBottom: '1.5rem' }}>
        <h3 style={{ color: '#fff', marginBottom: '0.5rem' }}>🔒 Consimțământ procesare date</h3>
        <p style={{ color: '#6060a0', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
          Conform Art. 7(3) GDPR poți retrage consimțământul oricând. Dacă îl retragi, nu vei mai putea folosi
          funcțiile Flexara, dar datele tale nu vor fi șterse automat — le poți șterge oricând din secțiunea de mai jos.
        </p>
        <button onClick={() => {
          if (window.confirm('Ești sigur că vrei să retragi consimțământul? Nu vei mai putea folosi Flexara până la reactivare.')) {
            retrageConsimtamant().then(() => window.location.reload()).catch(() => alert('Eroare. Încearcă din nou.'));
          }
        }} style={{
          padding: '0.6rem 1.2rem', borderRadius: '8px',
          border: '1px solid #3a2a00', background: '#2a1a00',
          color: '#c08030', cursor: 'pointer', fontSize: '0.9rem'
        }}>
          Retrage consimțământul
        </button>
      </div>

      {/* Ștergere cont */}
      <div style={{ background: '#2a0a0a', borderRadius: '16px', padding: '1.5rem', border: '1px solid #4a1a1a' }}>
        <h3 style={{ color: '#d06060', marginBottom: '0.5rem' }}>⚠️ Zonă periculoasă</h3>
        <p style={{ color: '#a06060', fontSize: '0.85rem', marginBottom: '1.5rem' }}>
          Ștergerea contului este permanentă și ireversibilă. Toate datele tale vor fi șterse conform Art. 17 GDPR.
        </p>
        <button onClick={() => {
          if (window.confirm('Ești sigur? Această acțiune este IREVERSIBILĂ. Toate datele tale vor fi șterse permanent.')) {
            if (window.confirm('Ultima confirmare — ștergem contul și toate datele tale?')) {
              const token = localStorage.getItem('token');
              fetch(`${process.env.REACT_APP_API_URL}/gdpr/sterge-cont`, {
                method: 'DELETE',
                headers: { Authorization: `Bearer ${token}` }
              }).then(() => {
                localStorage.removeItem('token');
                window.location.href = '/login';
              });
            }
          }
        }} style={{
          padding: '0.6rem 1.2rem', borderRadius: '8px',
          border: '1px solid #4a1a1a', background: '#3a0a0a',
          color: '#d06060', cursor: 'pointer', fontSize: '0.9rem'
        }}>
          🗑️ Șterge contul și toate datele
        </button>
      </div>

    </div>
  );
};

export default Profil;
